export default __webpack_public_path__ + "static/media/withdrawal-ico.2ee6e01d.svg";